/**
 * Device model via UA client hints (Chromium-only): modern Android reduces
 * the User-Agent model to the frozen token "K", the real one only comes from
 * high entropy values. Best-effort, never blocking — Firefox/Safari simply
 * omit it and the server-side User-Agent is enough.
 */
export async function detectDeviceModel(): Promise<string | undefined> {
  try {
    const uaData = (navigator as Navigator & {
      userAgentData?: { getHighEntropyValues(hints: string[]): Promise<{ model?: string }> };
    }).userAgentData;
    const hints = await uaData?.getHighEntropyValues(['model']);
    return hints?.model?.trim() || undefined;
  } catch {
    return undefined;
  }
}
